import axios from "axios";

const instance = axios.create({
  baseURL: "/acapi/"
});
instance.defaults.headers.common["platform"] = "web";
export default instance;



// WEBPACK FOOTER //
// ./src/api/instance.js